export default __webpack_public_path__ + "static/media/icon_publication_list.02a0fcec.svg";